const FORMALITY_DOMAIN_ID = 3;

const useDomaine = () => FORMALITY_DOMAIN_ID;

export default useDomaine;
